import { gql, useQuery } from '@apollo/client';
import { useLocation } from 'react-router-dom';
import type { ProductVehicle } from '../types';

const vehicleQuery = gql`
    query vehicle($id: String!) {
        vehicle: motorcycle(id: $id) {
            id
            model
            manufacturerName
            ccm
            ratedPower
            typeNumbers
            typeAcceptanceList
            manufacturingStartYear
            manufacturingEndYear
        }
    }
`;

const useVehicle = () => {
    const { search } = useLocation();
    const vehicleId = new URLSearchParams(search).get('vehicleId');
    const vehicleIdExists = !!vehicleId;

    const { data, loading, error } = useQuery<{
        vehicle: ProductVehicle;
    }>(vehicleQuery, {
        variables: {
            id: vehicleId,
        },
        fetchPolicy: 'cache-first',
        skip: !vehicleIdExists,
    });

    if (error) {
        throw error;
    }

    return { vehicle: data?.vehicle, vehicleIdExists, loading };
};

export default useVehicle;
